import { Auth } from "@/types/ApiResponses/Auth";
import { api } from "..";
import { QueryProps } from "@/types/Api";

export const getAuth = async (props: QueryProps): Promise<Auth> => {
  const res = await api.client.get("/auth-new/get-auth", {
    signal: props.signal,
  });
  return res.data;
};

export const signOut = async (): Promise<void> => {
  const res = await api.client.post("/auth-new/sign-out");
  return res.data;
};
